<template>
  <tr>
    <td style="width: 400px">
      {{ fileRecord.name() }}
    </td>
    <td
      style="width: 1px"
      class="text-no-wrap"
    >
      {{ fileRecord.size() }}
    </td>
    <td class="text--secondary">
      n/a
    </td>
    <td class="text--secondary">
      n/a
    </td>
    <td style="width: 300px">
      <v-progress-linear
        color="primary"
        :value="fileRecord.progress()"
      />
    </td>
    <td style="width: 1px">
      <v-icon
        color="error"
        @click="removeFileRecord(fileRecord)"
      >
        fa fa-times
      </v-icon>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'LibraryUploaderFile',
  props: {
    fileRecord: {
      type: Object,
      required: true
    }
  },
  methods: {
    removeFileRecord(fileRecord) {
      if (this.clearFilename()) {
        return
      }
      if (this.disabled === true) {
        return
      }
      this.$emit('remove', fileRecord)
    },
    clearFilename() {
      if (!(this.editable === true && this.isEditInputFocused)) {
        return false
      }
      this.$refs.input.value = ''
      this.isEditCancelable = true
      this.editInputBlured()
      return true
    }
  }
}
</script>

<style scoped>

</style>
